<template>
    <v-btn density="compact" @click="exportDialog=true" color="success" ><v-icon icon="mdi-file-excel"></v-icon></v-btn> 
    <!-- <v-icon @click="exportDialog=true" color="success" icon="mdi-file-excel" class="exporter"></v-icon> -->
    <div class="text-center pa-4">
      <v-dialog
        v-model="exportDialog"
        width="auto"
      >
        <v-card
          :max-width="store.state.component=='produits'?'700':'600'"
          prepend-icon="$error"
          :text="store.state.component=='produits'?'Vous voulez vraiment exporter les articles?':`Vous voulez vraiment exporter la réception ${store.state.numeroBon}?`"
          title="EXCEL"
        >
             <v-card-actions v-if="store.state.component!='produits'">
                <v-btn
                  density="compact"
                    text="Annuler"
                    @click="exportDialog = false"
                    variant="plain"
                    color="secondary"
                ></v-btn>
                <v-btn v-if="store.state.component!='produits'"
                    density="compact"
                    color="green"
                    text="Exporter"
                    @click="downloadFile('reception')"
                    variant="plain"
                ></v-btn>
            </v-card-actions>   
          <v-tabs v-if="store.state.component=='produits'"
            v-model="tab"

          > 
            <v-tab value="one" color="green">Articles</v-tab>
            <v-tab value="two" color="red">Promo</v-tab>
            <!-- <v-tab value="three">Promo</v-tab> -->
          </v-tabs>

          <v-card-text v-if="store.state.component=='produits'">
            <v-tabs-window v-model="tab">
              <v-tabs-window-item value="one">
                <v-btn density="compact"  text="Annuler"  @click="exportDialog = false"  variant="plain"  color="warning"></v-btn>
                <v-btn density="compact" text="Articles" @click="downloadFile('articles');exportDialog = false" variant="plain" color="green"></v-btn>
                <v-btn density="compact" text="Prix" @click="downloadFile('prix');exportDialog = false" variant="plain" color="red"></v-btn>
                <v-btn density="compact" text="Répartition" @click="downloadFile('repart');exportDialog = false" variant="plain" color="info"></v-btn>
              </v-tabs-window-item>

              <v-tabs-window-item value="two">
                <v-row style="margin-top: 1px;">
                  <v-col>
                    <v-btn   text="Annuler"  @click="exportDialog = false"    color="secondary"></v-btn>
                  </v-col>
                  <v-col>
                    <v-combobox item-title="libelle"  item-value="code" density="compact" variant="outlined"  small-chips solo label="Promo" :items="itemPromos" v-model="codePromo" ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-text-field density="compact" prefix="%" min="0" label="Promo" type="number" solo v-model="promo" variant="outlined" ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-btn  prepend-icon="mdi-file-excel" color="green" text="Exporter" @click="downloadFile('promo')"  ></v-btn>
                  </v-col>
                </v-row>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import exportFromJSON from "export-from-json";
import * as XLSX from 'xlsx';
import store from './store'
let exportDialog=ref(false)
let tab=ref(null)
let itemPromos=ref([
  {libelle:'PBG',code:'PBG'},
  {libelle:'Outlet',code:'OUTLET'},
  {libelle:'SOLDES',code:'SOLDES'},
  {libelle:'Black Friday',code:'BF'},
  {libelle:'Braderie',code:'BRADER'},
  {libelle:'Guess',code:'PGUESS'}
])
let codePromo=ref()
let promo=ref()

function downloadFile(type) {
  let headers= [
      'REFERENCE', 'ALIAS', 'DESIGNATION', 'CODE_MARQUE', 'MARQUE', 'COLLECTION',
      'CODE_THEME', 'THEME', 'REFOURN', 'CODE_BARRE', 'CODE_COULEUR', 'COULEUR',
      'TAILLE', 'PVC', 'PROMO', 'PRIX_PROMO', 'PERIODE_PROMO'
    ];
  if (type == 'articles' || type == 'promo' || type == 'reception' || type == 'solde') {
    exportDialog.value = false
    store.commit('updateWaiting')
    let data = []
    let fileName = ''
    let date = new Date()
    let day = new Date(Date.now()).toLocaleString().split(' ')[0].split('/').reverse().join('').replace('/', '')
    let hour = new Date(Date.now()).toLocaleString().split(' ')[1].split(':').join('')
    date = `${day}_${hour}`
    
    if (store.state.component == 'produits') {
      for (let marque in store.state.articles) {
        for (let theme in store.state.articles[marque]) {
          for (let ref in store.state.articles[marque][theme]) {
            for (let cab in store.state.articles[marque][theme][ref]) {
              const article = store.state.articles[marque][theme][ref][cab]
              let soldeData
              if (type == 'articles') {
                data.push({ ...article, repart: '', stock: '', achat_euro: '' })
                fileName = `ARTICLE_${date}_M.BENHAMADA`
              } else if (type == 'promo' && codePromo.value.code != 'SOLDES') {
                // console.log(codePromo.value.code);
                
                soldeData = {
                  REFERENCE: article.reference_y2  || '',
                  ALIAS: article.alias || article.reference_y2 || article.code_article || '',
                  DESIGNATION: article.designation || article.libelle || '',
                  CODE_MARQUE: article.code_marque || '',
                  MARQUE: article.marque || '',
                  COLLECTION: article.collection || '',
                  CODE_THEME: article.code_theme || '',
                  THEME: article.theme || '',
                  REFOURN: article.refourn || '',
                  CODE_BARRE: article.codebarre || article.ean_Y2 || '',
                  CODE_COULEUR: article.code_couleur || '',
                  COULEUR: article.couleur || '',
                  TAILLE: article.taille || '',
                  PVC: parseFloat(article.vte_euro),
                  PROMO: promo.value&&Number(promo.value)>0?
                  `${Math.round(Number(promo.value))}%`
                  :(article.prix_promo!=0?`${(Math.round(Number((article.vte_euro-article.prix_promo)/article.vte_euro)*100))}%`:''),
                  PRIX_PROMO: promo.value&&Number(promo.value)>0 ? Math.round((article.vte_euro - article.vte_euro * Number(promo.value)/100) * 10) / 10 : (article.prix_promo>0?article.prix_promo:''),
                  PERIODE_PROMO:codePromo.value.code?codePromo.value.code:article.type_promo
                }
                
                data.push(soldeData)
                fileName = `PROMO_${codePromo.value.code}_${date}_M.BENHAMADA`
              } else if (type == 'promo' && codePromo.value.code == 'SOLDES') {
                headers = [
                  'REFERENCE', 'ALIAS', 'DESIGNATION', 'CODE_MARQUE', 'MARQUE', 'COLLECTION',
                  'CODE_THEME', 'THEME', 'REFOURN', 'CODE_BARRE', 'CODE_COULEUR', 'COULEUR',
                  'TAILLE', '', 'PVC', 'VP', 'PAYS', 'D1%', 'D1€', 'D2%', 'D2€',
                  'D3%', 'D3€', 'OT%', 'OT€', 'CORRECTION'
                ];
                // Récupération des valeurs
                const vp = parseFloat(article.vp) || Number(promo.value)/100 || 0.3; // VP% - valeur de promotion
                const pvc = parseFloat(article.pvc || article.vte_euro) || 0; // PVC - prix de vente
                
                // Calculs selon les formules Excel
                const d1Percent = vp || ''; // D1% = IF(P3="","",P3)
                const d1Euro = d1Percent !== '' ? Math.round((pvc - pvc * d1Percent) * 10) / 10 : ''; // D1€
                const d2Percent =  d1Percent + 0.1; // D2%
                const d2Euro = d1Percent !== '' ? Math.round((pvc - pvc * d2Percent) * 10) / 10 : ''; // D2€
                const d3Percent =  d2Percent + 0.1; // D3%
                const d3Euro = d1Percent !== '' ? Math.round((pvc - pvc * d3Percent) * 10) / 10 : ''; // D3€
                const otPercent =  d2Percent + 0.1; // OT%
                const otEuro = d1Percent !== '' ? Math.round((pvc - pvc * otPercent) * 10) / 10 : ''; // OT€

                soldeData = {
                  REFERENCE: article.reference_y2  || '',
                  ALIAS: article.alias || article.reference_y2 || article.code_article || '',
                  DESIGNATION: article.designation || article.libelle || '',
                  CODE_MARQUE: article.code_marque || '',
                  MARQUE: article.marque || '',
                  COLLECTION: article.collection || '',
                  CODE_THEME: article.code_theme || '',
                  THEME: article.theme || '',
                  REFOURN: article.refourn || '',
                  CODE_BARRE: article.codebarre || article.ean_Y2 || '',
                  CODE_COULEUR: article.code_couleur || '',
                  COULEUR: article.couleur || '',
                  TAILLE: article.taille || '',
                  PVC: pvc,
                  VP: vp,
                  PAYS: article.pays || '',
                  'D1%': d1Percent,
                  'D1€': d1Euro,
                  'D2%': d2Percent,
                  'D2€': d2Euro,
                  'D3%': d3Percent,
                  'D3€': d3Euro,
                  'OT%': otPercent,
                  'OT€': otEuro,
                  CORRECTION: ''
                }
                data.push(soldeData)
                fileName = `SOLDES_H25_${date}_${store.state.user.username}`
              }
            }
          }
        }
      }
      store.commit('updateWaiting')
    } else {
      data = store.state.articlesFripe
      store.commit('updateWaiting')
    }
    
    fileName = (store.state.component == 'produits' ? fileName : `FRIPE_DEPO_${store.state.numeroBon}_${date}`)
    
    if (data && data.length > 0) {
      if (type == 'promo') {
      
        // Créer un nouveau workbook
        const wb = XLSX.utils.book_new();
        
        // Créer les données pour la feuille
        const wsData = [];
        
        // Ligne 1 : En-têtes (avec la colonne vide supplémentaire)
       
        wsData.push(headers);
        
        // Ligne 2 : Formules Excel (ligne de référence)
        const formulas = [
          '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '',
          '=IF(P2="","",P2)', // D1%
          '=IF(R2="","",ROUND(O2-O2*R2,1))', // D1€
          '=IF(R2>40%,R2,R2+10%)', // D2%
          '=IF(R2="","",ROUND(O2-O2*T2,1))', // D2€
          '=IF(T2>40%,T2,T2+10%)', // D3%
          '=IF(R2="","",ROUND(O2-O2*V2,1))', // D3€
          '=IF(T2>40%,T2,T2+10%)', // OT%
          '=IF(T2="","",ROUND(O2-O2*X2,1))', // OT€
          ''
        ];
        if(codePromo.value.code == 'SOLDES'){
          wsData.push(formulas);
        }
        
        
        // Lignes 3+ : Données calculées
        data.forEach((item, index) => {
          let row=[
            item.REFERENCE,
            item.ALIAS,
            item.DESIGNATION,
            item.CODE_MARQUE,
            item.MARQUE,
            item.COLLECTION,
            item.CODE_THEME,
            item.THEME,
            item.REFOURN,
            item.CODE_BARRE,
            item.CODE_COULEUR,
            item.COULEUR,
            item.TAILLE,
            item.PVC,
            item.PROMO,
            item.PRIX_PROMO,
            item.PERIODE_PROMO
          ]
          //console.log(row);
          
          let rowNum = index + 2; // Commencer à la ligne 3
          if(codePromo.value.code == 'SOLDES'){
            rowNum = index + 3
            row = [
              item.REFERENCE,
              item.ALIAS,
              item.DESIGNATION,
              item.CODE_MARQUE,
              item.MARQUE,
              item.COLLECTION,
              item.CODE_THEME,
              item.THEME,
              item.REFOURN,
              item.CODE_BARRE,
              item.CODE_COULEUR,
              item.COULEUR,
              item.TAILLE,
              '', // Colonne vide
              item.PVC,
              item.VP,
              item.PAYS,
              item['D1%'],
              item['D1€'],
              item['D2%'],
              item['D2€'],
              item['D3%'],
              item['D3€'],
              item['OT%'],
              item['OT€'],
              item.CORRECTION
            ];
          }
          wsData.push(row);
        });
        
        // Créer la feuille de calcul
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        
        // Définir les largeurs de colonnes (optionnel)
        const colWidths = [
          { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 12 }, { wch: 10 },
          { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 12 }, { wch: 15 },
          { wch: 12 }, { wch: 10 }, { wch: 8 }, { wch: 5 }, { wch: 8 },
          { wch: 10 }, { wch: 5 }, { wch: 5 }, { wch: 8 }, { wch: 8 },
          { wch: 5 }, { wch: 8 }, { wch: 5 }, { wch: 8 }, { wch: 5 }, { wch: 10 }
        ];
        ws['!cols'] = colWidths;
        
        // Ajouter la feuille au workbook
        XLSX.utils.book_append_sheet(wb, ws, "Soldes");
        
        // Générer et télécharger le fichier
        XLSX.writeFile(wb, `${fileName}.xlsx`);
      } else {
        // Pour les autres types, utiliser exportFromJSON
        let exportType = exportFromJSON.types.xls;
        exportFromJSON({ data, fileName, exportType });
      }
    }
  }
}
    
</script>

<style>

.np-list {
  padding: 2px 8px;
  margin: 12px 8px;
  border: 1px solid #107fda;
  background: #ffffff;
  border-radius: 6px;
  color: #107fda;
}
.np-btn {
  padding: 2px 8px;
  margin: 12px 8px;
  border: 1px solid #107fda;
  width: 110px;
  background: #107fda;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
}
</style>
